export const EditIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      className={`scale-[1.3] translate-y-1 ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 64 80"
      version="1.1"
      xmlSpace="preserve"
      x="0px"
      y="0px"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      fill="currentColor"
    >
      <g transform="matrix(4.12191,4.12191,-3.20593,3.20593,19.4364,-128.557)">
        <path d="M22,20.257C22,20.115 21.91,20 21.8,20C21.417,20 20.583,20 20.2,20C20.09,20 20,20.115 20,20.257C20,21.559 20,27.411 20,28.734C20,28.904 20.053,29.068 20.146,29.188C20.277,29.357 20.475,29.61 20.646,29.831C20.74,29.952 20.867,30.019 21,30.019C21.133,30.019 21.26,29.952 21.354,29.831C21.525,29.61 21.723,29.357 21.854,29.188C21.947,29.068 22,28.904 22,28.734C22,27.411 22,21.559 22,20.257Z" />
      </g>
      <g transform="matrix(4.12191,4.12191,-4.12191,4.12191,45.9999,-155.12)">
        <path d="M22,20C22,19.867 21.947,19.74 21.854,19.646C21.76,19.553 21.633,19.5 21.5,19.5C21.195,19.5 20.805,19.5 20.5,19.5C20.367,19.5 20.24,19.553 20.146,19.646C20.053,19.74 20,19.867 20,20C20,20.273 20,20.597 20,20.8C20,20.91 20.09,21 20.2,21C20.583,21 21.417,21 21.8,21C21.91,21 22,20.91 22,20.8C22,20.597 22,20.273 22,20Z" />
      </g>
    </svg>
  )
}
